import React, {useState} from "react";
import {FacebookLoginButton} from "./fbLoginButton.style";
import SmallLoader from "../utils/SmallLoader";
import {StyledButton} from "../style/global.style";

const FBLoginButton = ({ onSuccess, onFail }) => {
	const [showSpinner,setSpinner] = useState(true);
	const goToSelectFBAccount = async (fbRes) => {
		if (fbRes.accessToken && fbRes.userID) {
			onSuccess({ accessToken: fbRes.accessToken, userID: fbRes.userID, data_access_expiration_time: fbRes.fbExpire });
		} else {
			onFail();
		}
	};

	const softLoad = () =>{
		setTimeout(()=>{
			setSpinner(false)
		},1000)
	}

	window.onmessage = async function(fbRes){
		if (fbRes?.data?.data?.token && fbRes?.data?.data?.userID) {
			await goToSelectFBAccount({...fbRes.data.data, accessToken: fbRes.data.data.token});
		}
	};

	return (
		<div>
			{showSpinner ? <StyledButton><SmallLoader inline={true}/></StyledButton> : null}
			<FacebookLoginButton visible={showSpinner ? "hidden" : "visible"} onLoad={()=>softLoad()} src={`${process.env.REACT_APP_FB_LOGIN}/index.html`}/>
		</div>
	);
};
export default FBLoginButton;